import { render, staticRenderFns } from "./shared-footer.vue?vue&type=template&id=82ae2000"
import script from "./shared-footer.vue?vue&type=script&lang=js"
export * from "./shared-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports